import React from 'react';
import { ClickUI, ThemeModeType, useClickBadge } from '@make-software/csprclick-ui';

import { accountMenuItems } from './settings/account-menu';
import { ClickUIWrapper, TopBarContainer } from './styled';

export interface TopBarProps {
  themeMode: ThemeModeType | undefined;
  onThemeSwitch: () => void;
}

export const ClickTopBar: React.FC<TopBarProps> = ({ themeMode, onThemeSwitch }) => {
  const { setLeftBadge } = useClickBadge();

  // @ts-ignore
  setLeftBadge(null);

  return (
    <TopBarContainer>
      <ClickUIWrapper>
        <ClickUI
          topBarSettings={{
            // @todo Fix dark theme
            // onThemeSwitch: onThemeSwitch,
            accountMenuItems: accountMenuItems
          }}
          themeMode={themeMode}
        />
     </ClickUIWrapper>
   </TopBarContainer>
  );
};
